firebird.factory('promptService', [
    '$rootScope',
    function ($rootScope) {
        //This service is to keep track of open modals and/or sweet alerts

        var swalCounter = 0;
        var activeWindows = new Set();

        var service = {
            isModalActive: isModalActive,
            isPromptOpen: isPromptOpen,
            isModalOpen: isModalOpen,
            isSwalOpen: isSwalOpen,
            getModalCount: getModalCount,
            getSwalCount: getSwalCount
        };

        $rootScope.$on('show-modal', onShowModal);
        $rootScope.$on('hide-modal', onHideModal);
        $rootScope.$on('show-swal', onShowSwal);
        $rootScope.$on('hide-swal', onHideSwal);

        return service;

        ////////////////////////

        function isModalActive(modalName) {
            return activeWindows.has(modalName);
        }

        function isPromptOpen() {
            return service.isModalOpen() || service.isSwalOpen();
        }

        function isModalOpen() {
            return activeWindows.size > 0;
        }

        function isSwalOpen() {
            return swalCounter > 0;
        }

        function getModalCount() {
            return activeWindows.size;
        }

        function getSwalCount() {
            return swalCounter;
        }

        function onShowModal(e, modalName) {
            activeWindows.add(modalName);
        }

        function onHideModal(e, modalName) {
            activeWindows.forEach(function (element) {
                if (modalName.indexOf(element) !== -1) {
                    activeWindows.delete(element);
                }
            });
        }

        //Since only one swal can show at a time,
        //we either set the swalCount to 1 or 0
        function onShowSwal() {
            swalCounter = 1;
        }

        function onHideSwal() {
            swalCounter = 0;
        }
    }
]);
